/**
 * Recurring and Cash flow (TMMAPP-0145): the two pages that replaced "Planned / Cashflow forecast",
 * their paths, and the link that opens a series on Recurring from anywhere (a cash flow row, an
 * occurrence sheet, an envelope's forecast). The series rides in the navigation state, not the URL:
 * Recurring opens with that series expanded in its list view.
 */
export const RECURRING_PATH = '/me/recurring';
export const CASH_FLOW_PATH = '/me/cash-flow';

interface SeriesLinkState {
  seriesId: number;
}

/**
 * Recurring transactions' list view (the tab chosen, TMMAPP-0159 §F 28), with `seriesId` (when
 * known) expanded. Pass both to `navigate`.
 */
export function recurringSeriesLink(seriesId?: number): {
  to: string;
  options: { state?: SeriesLinkState };
} {
  return {
    to: `${RECURRING_PATH}?tab=transactions&view=list`,
    options: seriesId === undefined ? {} : { state: { seriesId } },
  };
}

/** The series a `recurringSeriesLink` carried, or `null` for any other navigation state. */
export function seriesIdFromState(state: unknown): number | null {
  if (typeof state !== 'object' || state === null || !('seriesId' in state)) return null;
  const { seriesId } = state as { seriesId: unknown };
  return typeof seriesId === 'number' && Number.isSafeInteger(seriesId) ? seriesId : null;
}
